<template>
	<div class="tabbar">
		<div id="header">
			<HeadModule :openTarget="'native/current'"/>
		</div>

		<div class="more_content">
			<div id="Sinput">
				<input type="text" name="" value="" placeholder="搜索需要的关键词" class="input" v-model='str'>
			</div>

			<div class="wrapper" ref="wrapper" :style="{height: this.thisHeigth}">
				<div class="bscroll-container">
					<div class="content">
						<div class="more_activity" v-for="(m, index) in list" :key="index">
							<div class="else_activity">
								<div class="more_activity_banner">
									<img :src="m.cover" alt="">
								</div>
								<div class="more_activity_txt">
									<p class="more_activity_title">{{ m.title }}</p>
									<p class="more_activity_time">报名时间:{{ m.reg_time }}</p>
									<div class="act_state">
										<p class="more_activity_people"> <span> {{ m.show_view_num }} </span>人参加</p>
										<p class="state" :style="{background: m.color}"> {{ m.state }} </p>
									</div>
								</div>
							</div>
							<WxOpenTag :extinfo="elseActivity(m.id)"/>
						</div>
					</div>

					<!-- 底部提示信息 -->
					<div class="bottom-tip" :style="{display: alertHook}">
						<span class="loading-hook">{{pullupMsg}}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="bottomBtn" id="bottomBtn" @click="btnClicked()">
			<img src="../assets/image/share.png" alt="">
			分享
		</div>
		<ShareShortcut :shareVisible="shareVisible" @shareCancel="shareCancel" :activityId="activityId" :detailUrl="thisUrl" />
	</div>
</template>
<script>
	import {pagehost} from '@/utils/http.js'
	import HeadModule from '@/components/HeadModule'
	import WxOpenTag from '@/components/WxOpenTag'
	import BScroll from "better-scroll"
	import ShareShortcut from '@/components/ShareShortcut'

	export default {
		components: {
			HeadModule: HeadModule,
			ShareShortcut: ShareShortcut,
			WxOpenTag: WxOpenTag,
		},
		data() {
			return {
				thisUrl: window.location.href,
				shareVisible: false,
				activityId: this.$route.query.id,
				more: [],
				pulldownMsg: '下拉刷新',
				pullupMsg: '正在努力加载',
				alertHook: 'none',
				content: '报名参加',
				str: '',
				thisHeigth: ''
			}
		},
		mounted() {
			this.$http({
				url: '/activity/activityList',
				method: 'get',
				params: {
					start: '0',
					limit: '10',
				},
			}).then((res) => {
				var headerHeight = document.getElementById('header').offsetHeight;
				var sinputHeight = document.getElementById('Sinput').offsetHeight;
				var bottomBtnHeight = document.getElementById('bottomBtn').offsetHeight;
				this.thisHeigth = window.innerHeight - headerHeight - sinputHeight - bottomBtnHeight + 'px';
				this.more = res.data;
				this.state();
			})
		},
		methods: {
			getData() {
				return new Promise(() => {
					this.$http({
						url: '/activity/activityList',
						method: 'get',
						params: {
							start: this.more.length,
							limit: '10',
						},
					}).then((res) => {
						let temp = res.data;
						if (temp == undefined) {
							this.pullupMsg = '暂无更多活动,敬请期待'
							return;
						}
						this.more = this.more.concat(temp);
						this.state();
					})
				})
			},
			state() {
				for (let i = 0; i < this.more.length; i++) {
					if (this.more[i].status == 1) {
						this.more[i]['state'] = '报名参加';
						this.more[i]['color'] = 'linear-gradient(to right, #E50101, #FE405A)';
					} else if (this.more[i].status == 2) {
						this.more[i]['state'] = '暂未开始';
						this.more[i]['color'] = 'linear-gradient(to right, #FBC2CA, #FFA4A4)';
					} else if (this.more[i].status == 3) {
						this.more[i]['state'] = '活动结束';
						this.more[i]['color'] = "#D8D8D8";
					}
				}
			},
			elseActivity(id) {
				let thisUrl = pagehost + '/html/activity/activity.html?activityId=' + id + '&hideNativeNav=1';
				let path = 'webView/detail?url=' + thisUrl;
				return  path;
			},
			// 分享
			btnClicked() {
				this.shareVisible = true;
			},
			shareCancel() {
				this.shareVisible = false;
			},
		},
		created() {
			const that = this;
			this.$nextTick(() => {
				this.scroll = new BScroll(this.$refs.wrapper, {
					probeType: 1,
					click: true
				})
				// 滑动过程中事件
				this.scroll.on('scroll', () => {
					this.alertHook = 'block';
				});
				//滑动结束松开事件
				this.scroll.on('touchEnd', (pos) => {
					if (pos.y < (this.scroll.maxScrollY - 30)) {
						setTimeout(() => {
							that.getData().then((res) => {
								that.pullupMsg = '正在努力加载';
								that.data = this.data.concat(res);
								that.scroll.refresh();
							})
						}, 3000)
					}
					this.alertHook = 'none';
				})
			})
		},
		computed: {
			list() {
				let arr = [];
				for (let i = 0; i < this.more.length; i++) {
					if (this.more[i].title.search(this.str) != -1) {
						arr.push(this.more[i])
					}
				}
				return arr
			}
		}
	}
</script>

<style lang="css" scoped>
	.wrapper {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	li {
		line-height: 50px;
		border-bottom: 1px solid #ccc;
		text-align: center;
	}

	/* 下拉、上拉提示信息 */
	.top-tip {
		position: absolute;
		top: -40px;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #555;
	}

	.bottom-tip {
		width: 100%;
		height: 35px;
		line-height: 35px;
		text-align: center;
		color: #777;
		background: #f2f2f2;
		position: absolute;
		bottom: -35px;
		left: 0;
	}

	/* 全局提示信息 */
	.alert-hook {
		position: fixed;
		top: 62px;
		left: 0;
		z-index: 2;
		width: 100%;
		height: 35px;
		line-height: 35px;
		text-align: center;
		color: #fff;
		font-size: 12px;
		background: rgba(7, 17, 27, 0.5);
	}

	#Sinput {
		padding-top: 15px;
		padding-bottom: 15px;
	}

	.input {
		box-sizing: border-box;
		padding-left: 10px;
		font-size: 14px;
		width: 100%;
		height: 36px;
		border: none;
		background-color: #F2F3F6;
	}

	.movieBox {
		height: 500px;
		overflow: scroll;
	}

	.down_more {
		height: 200px;
	}

	.more_content {
		padding: 0 15px;
	}
	
	.more_activity{
		position: relative;
	}

	.else_activity {
		display: flex;
		padding: 15px 10px;
	}

	.more_activity_banner {
		width: 123px;
		height: 85px;
	}

	.more_activity_banner img {
		width: 123px;
		height: 85px;
		object-fit: cover;
		border-radius: 5px;
	}

	.more_activity_txt {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-left: 12px;
	}

	.more_activity_title {
		font-size: 14px;
		color: #1D2023;
		font-weight: 600;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.more_activity_time {
		font-size: 11px;
		color: #606972;
	}

	.act_state {
		display: flex;
		justify-content: space-between;

	}

	.more_activity_people {
		font-size: 11px;
		color: #9CA3A9;
	}

	.more_activity_people span {
		font-size: 14px;
		color: #87B43B;
	}

	.state {
		color: #ffffff;
		padding: 0 10px;
		height: 22px;
		line-height: 22px;
		text-align: center;
		border-radius: 22px;
		font-size: 14px;
	}

	.bottomBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		color: #E50120;
		background-color: #ffffff;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.bottomBtn img {
		width: 17px;
		height: 17px;
		padding-right: 5px;
	}
</style>
